import { array, nativeEnum, number, object, string, TypeOf } from 'zod';

/* ------------------------- PurchaseRequestResponse ------------------------ */

export const PurchaseIntent = object({
    id: string(),
    stripePaymentIntentClientAppSecret: string(),
    price: object({
        currency: string(),
        value: number(),
    }),
});
export type PurchaseIntent = TypeOf<typeof PurchaseIntent>;

/* ---------------------------- PurchaseEventType --------------------------- */

export enum PurchaseEventType {
    Success = 'success',
    SystemError = 'system-error',
    NonPortableTerritory = 'non-portable-territory',
}

/* ------------------------------ PurchaseEvent ----------------------------- */

export const PurchaseEvent = object({
    event: nativeEnum(PurchaseEventType),
    occurred: string(),
});
export type PurchaseEvent = TypeOf<typeof PurchaseEvent>;

/* ------------------------- PurchaseEventsResponse ------------------------- */

export const PurchaseEventsResponse = object({
    data: array(PurchaseEvent),
});
export type PurchaseEventsResponse = TypeOf<typeof PurchaseEventsResponse>;

/* -------------------------- VerifiedPurchaseCode -------------------------- */

export const VerifiedPurchaseCode = PurchaseIntent.extend({
    created: string(),
    expiry: string(),
    purchaseId: string(),
    productId: string(),
});
export type VerifiedPurchaseCode = TypeOf<typeof VerifiedPurchaseCode>;
